import { LOCATIONS } from '@/data/content';

export const LocationsMarquee = () => {
  const row = [...LOCATIONS, ...LOCATIONS];
  return (
    <section data-testid="locations-marquee" className="relative py-16 md:py-24 border-y border-ink/10 overflow-hidden bg-void">
      <div className="marquee-track">
        {row.map((loc, i) => (
          <span key={i} className="flex items-center shrink-0">
            <span
              className={`font-clash font-semibold text-5xl md:text-7xl tracking-tight px-6 ${
                i % 2 === 0 ? 'text-outline' : 'text-ink'
              }`}
            >
              {loc}
            </span>
            <span className="text-brand-gold text-xl md:text-2xl">◆</span>
          </span>
        ))}
      </div>
      <p className="mt-8 text-center text-[10px] uppercase tracking-[0.4em] text-ink/55">
        Growth corridors we build across Telangana
      </p>
    </section>
  );
};
